import { SettingsSection } from '@/modules/external/components/customer/settings/settings-section.component';
import { Chip, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export function SettingsShippingPage() {
  const { t } = useTranslation('customer');

  return (
    <SettingsSection
      title={t('settings.shipping.title')}
      description={t('settings.shipping.description')}
      action={
        <Chip
          label={t('account.tabs.whiteLabelNew')}
          variant="filled"
          color="secondary"
          size="small"
        />
      }
    >
      <Stack spacing={2}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.7 }}
        >
          {t('account.whiteLabel.description')}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.7 }}
        >
          {t('account.whiteLabel.setup')}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.7 }}
        >
          {t('account.whiteLabel.pricing')}
        </Typography>
      </Stack>
    </SettingsSection>
  );
}
